/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface YearlyDistribution
 */
export interface YearlyDistribution {
    /**
     * 
     * @type {string}
     * @memberof YearlyDistribution
     */
    pId: string;
    /**
     * 
     * @type {number}
     * @memberof YearlyDistribution
     */
    year: number;
    /**
     * 
     * @type {number}
     * @memberof YearlyDistribution
     */
    sumDistributions: number;
}

/**
 * Check if a given object implements the YearlyDistribution interface.
 */
export function instanceOfYearlyDistribution(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "pId" in value;
    isInstance = isInstance && "year" in value;
    isInstance = isInstance && "sumDistributions" in value;

    return isInstance;
}

export function YearlyDistributionFromJSON(json: any): YearlyDistribution {
    return YearlyDistributionFromJSONTyped(json, false);
}

export function YearlyDistributionFromJSONTyped(json: any, ignoreDiscriminator: boolean): YearlyDistribution {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pId': json['p_id'],
        'year': json['year'],
        'sumDistributions': json['sum_distributions'],
    };
}

export function YearlyDistributionToJSON(value?: YearlyDistribution | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'p_id': value.pId,
        'year': value.year,
        'sum_distributions': value.sumDistributions,
    };
}

